import { render, staticRenderFns } from "./GroupClassMasterList.vue?vue&type=template&id=298cf337"
import script from "./GroupClassMasterList.vue?vue&type=script&lang=js"
export * from "./GroupClassMasterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports